import { ComponentType, PropsWithChildren } from 'react';

import { withRouter as withResourceRouter } from 'react-resource-router';

import { RouteComponentProps } from '../routes/types';

export const withRouter = <P extends Record<string, any>>(
  Component: ComponentType<PropsWithChildren<P & RouteComponentProps>>
) => {
  const WithResourceRouter = withResourceRouter(Component);

  function WrappedWithRouter(props: Omit<P, keyof RouteComponentProps>) {
    // @ts-ignore The types from `withRouter` from `react-resource-router` aren't as specific as they could be
    return <WithResourceRouter {...props} />;
  }

  return WrappedWithRouter;
};
